import ProgressBarContent from "./ProgressBarContent";
import ProgressBarSkeleton from "./ProgressBarSkeleton";

type ProgressBarContentProps = {
  currentProgress: number | null;
  currentTarget: number | null;
  totalTarget: number | null;
};

/**
 * A bar that visually displays some progress relative to a target figure and indicates by color if the progress is ahead or behind target;
 * Ahead of target = green, Behind target = red
 *
 * Displays a ProgressBarSkeleton if any prop is null
 */
export default function ProgressBar({
  currentProgress,
  currentTarget,
  totalTarget,
}: ProgressBarContentProps) {
  const hasAllValues =
    typeof currentProgress === "number" &&
    typeof currentTarget === "number" &&
    typeof totalTarget === "number" &&
    totalTarget !== 0; // ProgressBar must have a denominator
  return hasAllValues ? (
    <ProgressBarContent
      currentProgress={currentProgress as number}
      currentTarget={currentTarget as number}
      totalTarget={totalTarget as number}
    />
  ) : (
    <ProgressBarSkeleton data-component-name="Progress Bar" />
  );
}
